import MultChoiceObj from "../Models/QTypes/MultChoiceObj";
// import CheckboxObj from '../Models/QTypes/CheckboxObj';

const CHRO_QSet = [
  new MultChoiceObj({
    questionSet: {
      English: "How does your analytics sync with your source HCM system?",
    },
    answerSet: {
      English: [
        "Standard reporting does not keep in sync but can be updated as needed",
        "Manual updates are scheduled to update standard reports.",
        "New data can be automatically captured, but we still need manual updates to the analytics layer.",
        "Fully integrated analytic systems allow us to analyze new data and capabilities immediately.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "How do you correlate (what do you do to define or identify these groups) talent and compensation?",
    },
    answerSet: {
      English: [
        "We do not have a method for correlating top talent and compensation.",
        "We use manual solutions to analyze talent by department.",
        "We analyze talent performance at a corporate level.",
        "We leverage a unified analytics system to correlate compensation to top talent performance.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "What is your process for analyzing various dimensions of diversity?",
    },
    answerSet: {
      English: [
        "We only have basic employee reporting.",
        "We are in the early stages of implementing diversity tracking.",
        "Our D&I process is done ad hoc as needed.",
        "Our D&I process includes Integrated analytics to track, measure and evaluate results.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "What is your company’s approach to cloud adoption for HR?",
    },
    answerSet: {
      English: [
        "We use only on-premises solutions for HR reporting.",
        "Cloud used in some departments, but we are examining how it can support our HR strategies.",
        "We have a standalone cloud provider for HR disconnected from corp strategy.",
        "Cross functional corporate strategy includes HR systems processes and analytic reporting.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "How do you tie HR metrics to larger business and financial strategy?",
    },
    answerSet: {
      English: [
        "We combine Finance and HR data with a manual process in spreadsheets.",
        "Standard BI reporting but our systems aren't integrated.",
        "Both Finance and HR data is displayed in our strategy dashboards.",
        "Analytics system leverages enterprise-wide HR and Finance data for better strategy execution.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you monitor team effectiveness, retention, & more?",
    },
    answerSet: {
      English: [
        "We do not currently report on team effectiveness.",
        "Only during management performance reviews.",
        "Our HCM system displays basic team effectiveness metrics.",
        "We analyze key metrics like span of control, compa-ratio, and employee performance.",
      ],
    },
  }),
];

export default CHRO_QSet;
